import { removeToken } from "@senciamatch/frontend/libs/auth";
import { useSidebarMenuStore } from "@senciamatch/frontend/stores/useSidebarMenuStore";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SidebarMenu } from "./SidebarMenu";

export const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setIsOpen } = useSidebarMenuStore();

  const currentSidebar = (target: string) => {
    if (target === "matchings") {
      return location.pathname === "/matchings" || location.pathname.includes("matchings?");
    }
    return location.pathname.includes(target);
  };
  const handleLogout = async () => {
    removeToken();
    navigate("/login");
  };

  return (
    <div className="w-72 h-full bg-white flex-shrink-0 py-4 relative shadow-lg">
      <div className="flex flex-row justify-between items-center px-4">
        <Link to="/">
          <h1 className="text-2xl inline-block" style={{ fontFamily: "Outfit", fontWeight: "100" }}>
            Sencia Match
          </h1>
        </Link>
        <button
          className="i-hugeicons-arrow-left-double w-10 h-10 cursor-pointer bg-black-100"
          onClick={() => {
            console.log("Close sidebar clicked");
            setIsOpen(false);
          }}
          type="button"
        >
          <img src="/icons/double-arrow-left.svg" alt=">>" className="w-10 h-10 mt-1 p-2 fill-black" />
        </button>
      </div>

      <p className="text-gray-500 mt-10 mb-2 px-4 text-xs">マスターデータ</p>
      <SidebarMenu label="従業員一覧" icon="staff" isCurrent={currentSidebar("staffs")} link="/staffs" />
      <SidebarMenu label="物件一覧" icon="building" isCurrent={currentSidebar("buildings")} link="/buildings" />
      <SidebarMenu
        label="優先マッチング条件一覧"
        icon="high-priorities"
        isCurrent={currentSidebar("high-priorities")}
        link="/high-priorities"
      />
      <SidebarMenu
        label="NGマッチング条件一覧"
        icon="matching-ngs"
        isCurrent={currentSidebar("matching-ngs")}
        link="/matching-ngs"
      />
      <SidebarMenu
        label="マスターデータを追加"
        icon="plus"
        isCurrent={currentSidebar("add-master")}
        link="/add-master"
      />

      <p className="text-gray-500 mt-10 mb-2 px-4 text-xs">マッチング</p>
      <SidebarMenu
        label="新規マッチング"
        icon="matching"
        isCurrent={currentSidebar("matchings/new")}
        link="/matchings/new"
      />
      <SidebarMenu label="マッチング一覧" icon="history" isCurrent={currentSidebar("matchings")} link="/matchings" />

      <p className="text-gray-500 mt-10 mb-2 px-4 text-xs">その他設定</p>
      <SidebarMenu label="ユーザー一覧" icon="user" isCurrent={currentSidebar("users")} link="/users" />
      <SidebarMenu label="ログアウト" icon="logout" isCurrent={currentSidebar("logout")} onClick={handleLogout} />
    </div>
  );
};
